import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {Grid, TextField, Typography, FormHelperText} from '@material-ui/core';
import ConditionTable from './Condition/ConditionTable';
import ActionTable from './Action/ActionTable';
import {
  saveFilter,
  fetchFilter,
  ResetStatus as resetStatus,
  ResetMessage as resetMessage,
  getDropDownData,
} from '../../../../../../redux/reducers/EnableFramework/Filter';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {RECORD_TYPE} from '../../../../../../constants/Lookup';
import {getOptions} from '../../../../../../util/GetDropDownOptions';
import {getObject} from '../../../../../../util/GetDropdownObject';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ExpandMore} from '@material-ui/icons';
import FiltersSystemNotes from './FiltersSystemNotes';
import {makeStyles} from '@material-ui/core/styles';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const schema = Yup.object().shape({
  filterName: Yup.string().required('Filter code is required'),
  description: Yup.string().required('Description is required'),
});
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
    },
  },
  accordionDetailsStyling: {
    backgroundColor: '#fbfbfb',
    padding: '8px 0px 0px 0px',
    borderRadius: '0px 0px 8px 8px',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    backgroundColor: '#fbfbfb',
  },
}));
const AddFilterForm = ({
  setValueCode,
  filterCode,
  setFilterCode,
  setFilterCodeName,
  filterCodeName,
}) => {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {filterDataStatus, successMsg, errorMsg, isLoading, filterData} = useSelector(
    ({filter}) => filter,
  );
  const {dropDownData} = useSelector(({filter}) => filter);
  const initialValues = {
    filterName: filterData && filterData.name ? filterData.name : '',
    description: filterData && filterData.description ? filterData.description : '',
    recordType:
      filterData && filterData?.type ? getObject(filterData.type, RECORD_TYPE, dropDownData) : '',
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  useEffect(() => {
    filterCode && dispatch(fetchFilter(filterCode));
  }, [filterCode]);
  const [actionData, setActionData] = useState('');
  const [expanded, setExpanded] = useState();

  const [conditionData, setConditionData] = useState('');

  const [apiFieldListAction, setApiFieldListAction] = useState([]);

  useEffect(() => {
    if (filterData && filterData?.integrationFilterActions) {
      const fields = filterData?.integrationFilterActions.map((e) => e.actionId);
      setApiFieldListAction(fields);
    }
  }, [filterData]);
  const [deletedFieldsAction, setDeletedFieldsAction] = useState([]);
  useEffect(() => {
    if (actionData?.length >= 0) {
      const array = actionData.length ? actionData.map((a) => a.actionId) : [];
      const newFields = apiFieldListAction.filter((item) => !array?.includes(item));
      setDeletedFieldsAction(newFields);
    }
  }, [actionData]);

  const [apiFieldListCondition, setApiFieldListCondition] = useState([]);

  useEffect(() => {
    if (filterData && filterData?.integrationFilterConditions) {
      const fields = filterData?.integrationFilterConditions.map((e) => e.conditionId);
      setApiFieldListCondition(fields);
    }
  }, [filterData]);
  const [deletedFieldsCondition, setDeletedFieldsCondition] = useState([]);
  useEffect(() => {
    if (conditionData?.length >= 0) {
      const array = conditionData.length ? conditionData.map((a) => a.conditionId) : [];
      const newFields = apiFieldListCondition.filter((item) => !array?.includes(item));
      setDeletedFieldsCondition(newFields);
    }
  }, [conditionData]);

  useEffect(() => {
    if (filterDataStatus === 200) {
      setTimeout(() => {
        setValueCode(0);
        dispatch(resetStatus());
        dispatch(resetMessage());
      }, 2000);
    }
  }, [filterDataStatus]);

  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    if (Object.keys(filterData).length > 0) {
      const data = [...filterData?.integrationFilterConditions];
      const newData = data.map((i) => {
        return {
          ...i,
          conditionId: i?.conditionId ? i?.conditionId : 0,
          operator: i?.operator ? i.operator : '',
          srcField: i?.srcField ? i.srcField : '',
          toField: i?.toField ? i.toField : '',
          dateFormat: i?.dateFormat ? i.dateFormat : '',
          sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : '',
        };
      });
      setConditionData(newData);
    }
    if (Object.keys(filterData).length > 0) {
      const data = [...filterData?.integrationFilterActions];
      const newActionData = data.map((i) => {
        return {
          ...i,
          description: i?.description ? i.description : '',
          expression: i?.expression ? i.expression : '',
          format: i?.format ? i.format : '',
          actionId: i?.actionId ? i?.actionId : 0,
          name: i?.fieldCode ? i.fieldCode : '',
          returnValueType: i?.returnType ? i.returnType : '',
          sourceField: i?.sourceField ? i.sourceField : '',
          toField: i?.toField ? i.toField : '',
          type: i?.type ? i.type : '',
          sequenceNo: i?.sequenceNo ? Number(i?.sequenceNo) : '',

          disposition: i?.disposition ? i.disposition : '',
        };
      });
      setActionData(newActionData);
    }
  }, [filterData]);

  const handleSubmit = (values) => {
    const conditions =
      conditionData?.length > 0 ?
        conditionData.map((data) => {
          const conditionAction = {
            conditionId: data?.conditionId ? data?.conditionId : 0,
            operator: data?.operator ? data?.operator?.valueCode : '',
            srcField: data?.srcField ? data.srcField : '',
            toField: data?.toField ? data.toField : '',
            dateFormat: data?.dateFormat ? data.dateFormat : '',
            sequenceNo: data?.seqNo ? data.seqNo : '',
          };
          return conditionAction;
        }) :
        [];
    const actions =
      actionData.length > 0 ?
        actionData.map((data) => {
          const action = {
            description: data?.description ? data.description : '',
            expression: data?.expression ? data.expression : '',
            disposition: data?.disposition ? data.disposition : '',
            format: data?.format ? data.format : '',
            actionId: data?.actionId ? data.actionId : 0,
            name: data?.fieldCode ? data.fieldCode : '',
            returnValueType: data?.returnType ? data.returnType : '',
            sourceField: data?.sourceField ? data.sourceField : '',
            toField: data?.toField ? data.toField : '',
            type: data?.type ? data.type : '',
            sequenceNo: data?.seqNo ? data.seqNo : '',
          };
          return action;
        }) :
        [];

    const postData = {
      description: values?.description ? values?.description : '',
      id: filterData?.id ? filterData?.id : 0,
      name: values?.filterName ? values.filterName : '',
      type: values?.recordType ? values.recordType?.valueCode : '',
      actionDeletedIds: deletedFieldsAction,
      conditionDeletedIds: deletedFieldsCondition,
      conditionList: conditions?.length > 0 ? conditions : [],
      actionList: actions?.length > 0 ? actions : [],
    };
    dispatch(saveFilter(postData));
  };
  return (
    <div>
      <Formik
        onSubmit={(values, {validate}) => {
          handleSubmit(values);
          validate(values);
        }}
        initialValues={initialValues}
        validationSchema={schema}
        validateOnChange={true}
        validateOnBlur={false}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
            touched,
            errors,
          } = props;
          return (
            <div className="col-md-12">
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <Grid container className="global-field-textfields" spacing={2}>
                    <Grid item xs={4} xl={3} md={3} sm={3} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter Filter Code"
                        label="Filter Code"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        name="filterName"
                        value={values.filterName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.filterName}
                        error={touched.filterName && errors.filterName}
                      />
                      <FormHelperText>{touched.filterName && errors.filterName}</FormHelperText>
                    </Grid>
                    <Grid item xs={4} xl={3} md={3} sm={3} className="form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="recordType"
                        id="recordType"
                        size="small"
                        disabled
                        value={values.recordType}
                        options={getOptions(RECORD_TYPE, dropDownData)}
                        getOptionDisabled={(option) => option.valueCode === null}
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value ?
                            option.valueCode + ' - ' + option.value :
                            option.value === null ?
                              option.valueCode :
                              option.value;
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('recordType', value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              {...params}
                              error={touched.recordType && errors.recordType}
                              variant="outlined"
                              margin="dense"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Record Typess"
                              placeholder="Select Record Type"
                            />
                          </div>
                        )}
                      />
                    </Grid>

                    <Grid item xs={4} xl={6} md={6} sm={6} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Description`}
                        label="Description"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        required
                        touched={touched.description}
                        error={touched.description && errors.description}
                      />
                      <FormHelperText>{touched.description && errors.description}</FormHelperText>
                    </Grid>
                  </Grid>
                  <Grid>
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h3">Conditions: </Typography>
                      </div>
                      <ConditionTable
                        conditionData={conditionData}
                        setConditionData={setConditionData}
                      />
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h3">Actions: </Typography>
                      </div>
                      <ActionTable actionData={actionData} setActionData={setActionData} />
                    </div>
                  </Grid>
                </div>
              </form>
              {filterData?.name && (
                <div className={`${classes1.root} mt-3`}>
                  <Accordion
                    className="accordion-styling"
                    expanded={expanded === 'panel1'}
                    onChange={handleAccordionChange('panel1')}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore sx={{fontSize: '0.9rem'}} />}
                      // {...props}
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Typography className={classes1.heading}>Filters Notes</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes1.detailsCard}>
                      <FiltersSystemNotes
                        setFilterCode={setFilterCode}
                        filterCode={filterCode}
                        setFilterCodeName={setFilterCodeName}
                        filterCodeName={filterCodeName}
                      />
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
            </div>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default AddFilterForm;
